import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import '../Customers/CustomersStyle.css';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';
import 'react-flags-select/css/react-flags-select.css';
import * as yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import TermsAndConditions from './TermsAndConditions';

const CompanyInfoData = {
    OrganizationID: "",
    BankName: "",
    BillingAddress: "",
    AccountNumber: 0,
    IFSCCode: "",
    Branch: "",
    QuotationTerms: "",
    ThemeColor: "",
    InvoiceTerms: "",
    LRTerms: "",
    AccountType: 0,
    AccountName: ""
};

const ComanyInfoSchema = yup.object().shape({
    AccountName: yup.string().required(),
    Branch: yup.string().required(),
    IFSCCode: yup.string().required(),
    AccountNumber: yup.number().required().min(1, 'Bank Account is a required field'),
    BankName: yup.string().required(),
    BillingAddress: yup.string().required(),
});

const DocTheme = [
    { ID: 1, color: "#ffd732", name: "Orange" }, { ID: 2, color: "#9662eb", name: "blue" },
    { ID: 3, color: "#bbb", name: "Gray" }, { ID: 4, color: "#c4f295", name: "Green" }
];

const CompanyInfo = () => {

    const { CurrentTheme } = useContext(ThemeContext);
    const [CompanyInfo, setCompanyInfo] = useState({});
    const [AdditionalOrg, setAdditionalOrg] = useState(CompanyInfoData);
    const [SelectedDocTheme, setSelectedDocTheme] = useState("");
    const [OrgLogo, setOrgLogo] = useState(null);
    const [LogoImage, setLogoImage] = useState(null);
    const [displayTerms, setdisplayTerms] = useState("none");
    const [Terms, setTerms] = useState("");
    const [Selection, setSelection] = useState("");


    useEffect(() => {
        FetchCompanyInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onTextChange = (e) => {
        setAdditionalOrg({ ...AdditionalOrg, [e.target.name]: e.target.value });
    };

    const onNumberChange = (e) => {
        let value = e.target.value === "" ? 0 : parseInt(e.target.value);
        setAdditionalOrg({ ...AdditionalOrg, [e.target.name]: value });
    };

    const hideTerms = () => {
        setdisplayTerms("none");
    }

    const FetchCompanyInfo = () => {
        var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
        if (userData) {
            var parsedUserData = JSON.parse(userData);
            var CompanyDetails = parsedUserData.Organization.length > 0 ? parsedUserData.Organization : null;
            if (CompanyDetails) {
                setCompanyInfo(CompanyDetails[0]);
                GetOrganizationLogo(CompanyDetails[0].Logo);
                GetAdditionalOrgInfo(CompanyDetails[0]._id);
            }
        }
        else {

        }
    };

    const GetAdditionalOrgInfo = (OrgID) => {
        if (OrgID !== "") {
            Axiosfetch(baseURL + "GetActiveAdditionalOrganizationByID", "POST", { ID: OrgID }, companyAdditonalInfoEditSuccess, Failure);
        }
    };

    const companyAdditonalInfoEditSuccess = (data) => {
        if (data.length > 0) {
            setAdditionalOrg(data[0]);
            setSelectedDocTheme(data[0].ThemeColor);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const SaveCompanyInfoDetails = (companyInfo) => {
        if (ValidateInfoDetails()) {
            ComanyInfoSchema.validate(AdditionalOrg).then(valid => {
                var APIOperation = AdditionalOrg.OrganizationID === "" ? "CreateAdditionalOrganization" : "EditAdditionalOrganization";
                var additionalDetails = AdditionalOrg;
                additionalDetails.OrganizationID = companyInfo._id;
                additionalDetails.QuotationTerms = additionalDetails.QuotationTerms === "" ? null : additionalDetails.QuotationTerms;
                additionalDetails.InvoiceTerms = additionalDetails.InvoiceTerms === "" ? null : additionalDetails.InvoiceTerms;
                additionalDetails.ThemeColor = SelectedDocTheme === "" ? null : SelectedDocTheme;
                Axiosfetch(baseURL + APIOperation, "POST", additionalDetails, companyInfoEditSuccess, Failure);
            }).catch(err => {
                Alert.error(err.message, {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            });
        }
    };

    const ValidateInfoDetails = () => {
        let infoErr = "";
        if (AdditionalOrg.AccountNumber === 0 || (AdditionalOrg.AccountNumber !== 0 && !/^[0-9]{9,18}$/.test(AdditionalOrg.AccountNumber.toString()))) {
            infoErr = "Please enter valid Account Number";
        }
        else if (AdditionalOrg.IFSCCode !== "" && !/^[A-Za-z]{4}[0][A-Z0-9]{6}$/.test(AdditionalOrg.IFSCCode.toString())) {
            infoErr = "Please enter valid IFSC Code";
        }
        else if (AdditionalOrg.AccountType === 0) {
            infoErr = "Please enter valid Account Type";
        }

        if (infoErr !== "") {
            Alert.error(infoErr, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return false;
        }

        return true;
    };

    const companyInfoEditSuccess = (data) => {
        if (data.length > 0) {
        }

        Alert.success("Company Info Updated Successfully", {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
    };

    const onLogoFrontAttach = (e) => {
        var selectedFile = e.target.files[0];
        if (selectedFile.type === "image/jpeg" || selectedFile.type === "image/png" ||
            selectedFile.type === "image/jpg") {
            var reader = new FileReader();
            setOrgLogo(selectedFile);

            reader.onload = function (upload) {
                setLogoImage(upload.target.result);

            };

            reader.readAsDataURL(selectedFile);
        }
        else {
            Alert.error("File Type allowed are : PNG , JPG, JPEG", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnLogoSave = () => {
        let formData = new FormData();
        formData.append('file', OrgLogo);
        Axiosfetch(baseURL + "UploadOrganizationLogo", "POST", formData, OrgUploadSuccess, Failure);
    };

    const OrgUploadSuccess = (data) => {
        if (data.success) {
            Axiosfetch(baseURL + "EditOrganizationLogo", "POST", { Logo: data.filename, ID: AdditionalOrg.OrganizationID }, OrgEditSuccess, Failure);
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OrgEditSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const onThemeSelect = (themecolor) => {
        setSelectedDocTheme(themecolor);
    };

    const GetOrganizationLogo = (logo) => {
        let file = logo;
        if (file !== null) {
            Axiosfetch(baseURL + "GetOrganizationLogo", "POST", { fileName: file }, LogoSuccess, Failure);
        }
    };

    const LogoSuccess = (data) => {
        if (data.success) {
            setLogoImage(data.fileData);
        }
    };

    const OnQuotationTermsEdit = (name) => {
        setdisplayTerms("block");
        setSelection(name);

        switch (name) {
            case "QuotationTerms": setTerms(AdditionalOrg.QuotationTerms ? AdditionalOrg.QuotationTerms : "");
                break;
            case "InvoiceTerms": setTerms(AdditionalOrg.InvoiceTerms ? AdditionalOrg.InvoiceTerms : "");
                break;
            case "LRTerms": setTerms(AdditionalOrg.LRTerms ? AdditionalOrg.LRTerms : "");
                break;
            default: setTerms(AdditionalOrg.QuotationTerms ? AdditionalOrg.QuotationTerms : "");
        };
    };

    const AddNewRow = () => {
        if (Terms === "") {
            setTerms(" ");
        }
        else {
            // check if prev row is blank, New row can be added only if prev row is filled
            var termsList = Terms.split('|');
            if (termsList.length === 0 || (termsList.length > 0 && termsList[termsList.length - 1] !== "")) {
                setTerms(Terms + "|");
            }
        }
    };

    const RemoveRow = (content, index) => {

        if (Terms.indexOf('|') === -1) {
            // remove the only element
            setTerms("");
        }
        else {
            let selectedTerm = Terms.split('|');
            selectedTerm.splice(index, 1);
            setTerms(selectedTerm.join("|"));
        }
    };

    const UpdateRow = (updatedData) => {
        if (updatedData.Name !== undefined) {
            switch (updatedData.Name) {
                case "QuotationTerms": setAdditionalOrg({ ...AdditionalOrg, [updatedData.Name]: updatedData.Data });
                    break;
                case "InvoiceTerms": setAdditionalOrg({ ...AdditionalOrg, [updatedData.Name]: updatedData.Data });
                    break;
                case "LRTerms": setAdditionalOrg({ ...AdditionalOrg, [updatedData.Name]: updatedData.Data });
                    break;
                default: break;
            };
        }
    };

    const onCloseTerms = () => {
        setdisplayTerms("none");
    };

    const OnAccountTypeChange = (e) => {
        let AccountTypeValue = parseInt(e.target.value);
        setAdditionalOrg({ ...AdditionalOrg, [e.target.name]: AccountTypeValue });
    }

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="col-md-7 col-sm-7 col-7 align-right">
                        <h5 style={{ fontWeight: "500" }}>Company Information</h5>
                    </div>
                    <div className="col-md-5 col-sm-5 col-5 buttonresponsive align-right">
                        <button className={`btn btn-Save ${CurrentTheme}Focus`} onClick={() => SaveCompanyInfoDetails(CompanyInfo)}>Save</button>
                    </div>
                </div>
                <div className="row" style={{
                    padding: "0 10px", height: "76vh", overflow: "auto", overflowX: "hidden",
                    scrollbarColor: "#005582 transparent"
                }}>
                    <div className="col-md-6">
                        <div className="shadow1" style={{ marginTop: "1.4rem", border: "1px solid #ccc", borderRadius: "6px" }}>
                            <div>
                                <h5 style={{ padding: "10px", backgroundColor: "#ddd" }}>Company Details</h5>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="text-field">
                                        <input placeholder="" name="Name" value={CompanyInfo.Name ? CompanyInfo.Name : ""}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>Name<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="text-field">
                                        <textarea placeholder="" name="BillingAddress" value={AdditionalOrg.BillingAddress}
                                            onChange={(e) => onTextChange(e)}></textarea>
                                        <span>Billing Address<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="text-field">
                                        <input placeholder="" name="GSTNumber" value={CompanyInfo.GSTNumber ? CompanyInfo.GSTNumber : ""}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>GST Number</span>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="text-field">
                                        <input placeholder="" name="ContactNumber" value={CompanyInfo.Contact ? CompanyInfo.Contact : ""}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>Contact Number</span>
                                    </div>
                                </div>
                                <div className="col-md-4" style={{ marginBottom: "20px" }}>
                                    <div className="text-field">
                                        <input placeholder="" name="ContactNumber" value={CompanyInfo.AlternateContact ? CompanyInfo.AlternateContact : ""}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span >Alternate Number</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="shadow1" style={{ marginTop: "1.4rem", border: "1px solid #ccc", borderRadius: "6px" }}>
                            <div>
                                <h5 style={{ padding: "10px", backgroundColor: "#ddd" }}>Bank Details</h5>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="text-field">
                                        <input placeholder="" name="AccountName" value={AdditionalOrg.AccountName}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>Account Name<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <select onChange={OnAccountTypeChange} value={(AdditionalOrg.AccountType ? AdditionalOrg.AccountType : 0)} name="AccountType" style={{ width: "90%", padding: "10px", margin: "10px" }}>
                                        <option value="0">Select Account Type</option>
                                        <option value="1">Current</option>
                                        <option value="2">Savings</option>
                                        <option value="3">CC</option>
                                        <option value="4">OD</option>
                                    </select>
                                </div>
                                <div className="col-md-12">
                                    <div className="text-field">
                                        <input placeholder="" name="BankName" value={AdditionalOrg.BankName}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>Bank Name<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="text-field">
                                        <input placeholder="" name="AccountNumber" value={AdditionalOrg.AccountNumber}
                                            onChange={(e) => onNumberChange(e)}
                                            type="text"></input>
                                        <span>Bank Account<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-field">
                                        <input placeholder="" name="IFSCCode" value={AdditionalOrg.IFSCCode}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>IFSC Code<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-field">
                                        <input placeholder="" name="Branch" value={AdditionalOrg.Branch}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>Branch<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="shadow1" style={{ marginTop: "1.4rem", border: "1px solid #ccc", borderRadius: "6px" }}>
                            <div>
                                <h5 style={{ padding: "10px", backgroundColor: "#ddd" }}>Company Logo</h5>
                            </div>
                            <div className="row">
                                <div className="col-md-10">
                                    <div className="text-field">
                                        <input placeholder="" name="Logo"
                                            onChange={onLogoFrontAttach} accept="image/png, image/jpeg"
                                            type="file"></input>
                                        <span >Attachment</span>
                                    </div>
                                </div>
                                <div className="col-md-2 align-center" style={{ margin: "auto" }}>
                                    <button className={`btn btn-Save ${CurrentTheme}Focus`} onClick={OnLogoSave}>Upload</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="shadow1" style={{ marginTop: "1.4rem", border: "1px solid #ccc", borderRadius: "6px" }}>
                            <div>
                                <h5 style={{ padding: "10px", backgroundColor: "#ddd" }}>
                                    Document Settings
                                </h5>
                            </div>
                            <div className="row" style={{ padding: "15px 0px", justifyContent: "space-evenly" }}>
                                {DocTheme.length > 0 && DocTheme.map(docColor => (
                                    <div style={{ width: ((SelectedDocTheme && SelectedDocTheme === docColor.color) ? "70px" : "55px") }} key={docColor.ID} onClick={() => onThemeSelect(docColor.color)} className="col-md-2 col-sm-2 cursor">
                                        <div style={{
                                            height: "35px", width: ((SelectedDocTheme && SelectedDocTheme === docColor.color) ? "70px" : "55px"),
                                            borderRadius: "30px", backgroundColor: docColor.color,
                                            border: ((SelectedDocTheme && SelectedDocTheme === docColor.color) ? "4px solid #005582" : "")
                                        }}></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="shadow1" style={{ marginTop: "1.4rem", border: "1px solid #ccc", borderRadius: "6px" }}>
                            <div>
                                <h5 style={{ padding: "10px", backgroundColor: "#ddd" }}>Terms And Conditions</h5>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div style={{ textAlign: "right", paddingRight: "1rem" }} >
                                        <span className="hover-style" onClick={() => OnQuotationTermsEdit("QuotationTerms")} data-tip="Edit Quotation Terms and Conditions">
                                            <FontAwesomeIcon icon={faEdit}></FontAwesomeIcon>
                                        </span>
                                    </div>
                                    <div className="text-field">
                                        <textarea placeholder="" name="QuotationTerms" rows="4" value={AdditionalOrg.QuotationTerms ? AdditionalOrg.QuotationTerms : ""}
                                            onChange={(e) => onTextChange(e)}></textarea>
                                        <span>Quotation</span>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div style={{ textAlign: "right", paddingRight: "1rem" }}>
                                        <span className="hover-style" onClick={() => OnQuotationTermsEdit("InvoiceTerms")} data-tip="Edit Invoice Terms and Conditions">
                                            <FontAwesomeIcon icon={faEdit}></FontAwesomeIcon>
                                        </span>
                                    </div>
                                    <div className="text-field">
                                        <textarea placeholder="" name="InvoiceTerms" rows="4" value={AdditionalOrg.InvoiceTerms ? AdditionalOrg.InvoiceTerms : ""}
                                            onChange={(e) => onTextChange(e)}></textarea>
                                        <span>Invoice</span>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div style={{ textAlign: "right", paddingRight: "1rem" }}>
                                        <span className="hover-style" onClick={() => OnQuotationTermsEdit("LRTerms")} data-tip="Edit LR Terms and Conditions">
                                            <FontAwesomeIcon icon={faEdit}></FontAwesomeIcon>
                                        </span>
                                    </div>
                                    <div className="text-field">
                                        <textarea placeholder="" name="LRTerms" rows="4" value={AdditionalOrg.LRTerms ? AdditionalOrg.LRTerms : ""}
                                            onChange={(e) => onTextChange(e)}></textarea>
                                        <span>LR</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div style={{ padding: "0 8%" }}>
                            <table className="table">
                                <tbody>
                                    {LogoImage && (<tr>
                                        <td colSpan="2">
                                            <u><h5 style={{ textAlign: "center" }}>Logo</h5></u>
                                            <div style={{ textAlign: "center" }}>
                                                <img className="companylogoStyle" alt="Company Logo" width="400" height="400" src={LogoImage}></img>
                                            </div>
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
            <div id="myModalTerms" className="modal" style={{ display: displayTerms }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Terms and Condition Info</span>
                        <span className="close" onClick={hideTerms}>&times;</span>
                    </div>
                    <div>
                        <TermsAndConditions selection={Selection} Terms={Terms} AddNewRow={AddNewRow} RemoveRow={RemoveRow} UpdateRow={UpdateRow} onCloseTerms={onCloseTerms}></TermsAndConditions>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompanyInfo;